/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeCircleIcon20Light = forwardRef('ShapeCircleIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 9.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0ZM9.5 3a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Z" })));
});
